import React, { useEffect, useState } from 'react';
import api from '../api';
import { useParams, useNavigate } from 'react-router-dom';

export default function PurchaseBillPaymentsPage() {
  const { billId } = useParams();
  const navigate = useNavigate();
  const [bill, setBill] = useState(null);
  const [payments, setPayments] = useState([]);
  const [form, setForm] = useState({
    Amount: '',
    PaymentDate: new Date().toISOString().slice(0, 10),
    PaymentMode: '',
    Notes: ''
  });

  useEffect(() => {
    fetchBill();
    fetchPayments();
  }, []);

  const fetchBill = async () => {
    const res = await api.get('/purchase-bills');
    const found = res.data.find(b => b.PurchaseBillID === parseInt(billId));
    setBill(found);
  };

  const fetchPayments = async () => {
    const res = await api.get(`/purchase-bills/${billId}/payments`);
    setPayments(res.data);
  };

  const handleChange = e => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async e => {
    e.preventDefault();
    if (!form.Amount || !form.PaymentDate || !form.PaymentMode) {
      alert('Fill all required fields');
      return;
    }
    await api.post(`/purchase-bills/${billId}/payments`, form);
    setForm({ Amount: '', PaymentDate: new Date().toISOString().slice(0, 10), PaymentMode: '', Notes: '' });
    fetchPayments();
  };

  const handleDelete = async (id) => {
    if (window.confirm('Delete this payment?')) {
      await api.delete(`/purchase-payments/${id}`);
      fetchPayments();
    }
  };

  const paid = payments.reduce((sum, p) => sum + parseFloat(p.Amount || 0), 0);
  const totalDue = bill ? parseFloat(bill.TotalAmount || 0) - paid : 0;

  return (
    <div className="container mt-4">
      <h2>Payments for Purchase Bill #{bill?.BillNo || billId}</h2>
      {bill && (
        <div className="mb-3">
          <strong>Supplier:</strong> {bill.SupplierName} <br />
          <strong>Bill Amount:</strong> ₹{parseFloat(bill.TotalAmount || 0).toFixed(2)} <br />
          <strong>Paid:</strong> ₹{paid.toFixed(2)} <br />
          <strong>Due:</strong> <span className={totalDue > 0 ? "text-danger" : "text-success"}>₹{totalDue.toFixed(2)}</span>
        </div>
      )}
      <form className="row g-2 mb-3" onSubmit={handleSubmit}>
        <div className="col-md-2">
          <input className="form-control" type="number" name="Amount" placeholder="Amount" value={form.Amount} onChange={handleChange} required />
        </div>
        <div className="col-md-2">
          <input className="form-control" type="date" name="PaymentDate" value={form.PaymentDate} onChange={handleChange} required />
        </div>
        <div className="col-md-2">
          <select className="form-control" name="PaymentMode" value={form.PaymentMode} onChange={handleChange} required>
            <option value="">Mode</option>
            <option value="Cash">Cash</option>
            <option value="Bank">Bank</option>
            <option value="UPI">UPI</option>
            <option value="Card">Card</option>
            <option value="Other">Other</option>
          </select>
        </div>
        <div className="col-md-4">
          <input className="form-control" name="Notes" placeholder="Notes" value={form.Notes} onChange={handleChange} />
        </div>
        <div className="col-md-2 d-flex align-items-end">
          <button className="btn btn-primary w-100" type="submit">Add Payment</button>
        </div>
      </form>

      <table className="table table-bordered table-striped">
        <thead>
          <tr>
            <th>Amount</th>
            <th>Date</th>
            <th>Mode</th>
            <th>Notes</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {payments.length === 0 && (
            <tr><td colSpan="5" className="text-center text-muted">No payments yet</td></tr>
          )}
          {payments.map(p => (
            <tr key={p.PurchasePaymentID}>
              <td>₹{parseFloat(p.Amount || 0).toFixed(2)}</td>
              <td>{p.PaymentDate}</td>
              <td>{p.PaymentMode}</td>
              <td>{p.Notes}</td>
              <td>
                <button className="btn btn-sm btn-danger" onClick={() => handleDelete(p.PurchasePaymentID)}>Delete</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <button className="btn btn-secondary mt-3" onClick={() => navigate('/purchase-bills')}>← Back to Bills</button>
    </div>
  );
}
